const addressReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default addressReducer;